var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.944645 0.522343C1.33715 0.129841 1.97352 0.129841 2.36602 0.522343L7.68571 5.84204L13.0054 0.522343C13.3979 0.129841 14.0343 0.129841 14.4268 0.522343C14.8193 0.914844 14.8193 1.55122 14.4268 1.94372L9.10709 7.26341L14.4268 12.5831C14.8193 12.9756 14.8193 13.612 14.4268 14.0045C14.0343 14.397 13.3979 14.397 13.0054 14.0045L7.68571 8.68478L2.36602 14.0045C1.97352 14.397 1.33715 14.397 0.944645 14.0045C0.552143 13.612 0.552143 12.9756 0.944645 12.5831L6.26434 7.26341L0.944645 1.94372C0.552143 1.55122 0.552143 0.914844 0.944645 0.522343Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconLight);
export default __webpack_public_path__ + "static/media/close-icon-light.1135b5c69c1eb1a99fb3e721b258e8a8.svg";
export { ForwardRef as ReactComponent };